import React from 'react';
import Formsy from 'formsy-react';
import Modal from '../shared/Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import RichTextEditor, { createValueFromString } from 'react-rte';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { generateOccasionMenuEmail } from '../../helpers/emailGenerators';
import { RTE_DEFAULT_TOOLBAR_CONFIG } from '../../const';
import withSplashMessage from '../splashMessage/withSplashMessage';

class MenuSendOccasionModal extends React.Component {
  state = {
    emailBody: createValueFromString('<p></p>', 'html'),
    recipients: ''
  };

  render() {
    const { emailBody } = this.state;
    if (!this.props.isOpen) return '';
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.closeModal}>
        <Formsy onValidSubmit={this.onSubmit}>
          <h2 className="h2 cms__section-head">Send the Occasion Menu</h2>
          <div className="form__row">
            <p className="p">Email Address</p>
            <FormsySimpleInput
              type="text"
              name="recipients"
              validations={'isEmailList'}
              value={this.state.recipients}
              onChange={this.handleChange}
              required
            />
            <p className="small">
              Separate multiple email addresses with commas.
            </p>
          </div>

          <RichTextEditor
            value={emailBody}
            onChange={this.handleRTEChange}
            className="text-area text-area--edit"
            toolbarConfig={RTE_DEFAULT_TOOLBAR_CONFIG}
            autoFocus={true}
          />

          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={this.props.closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="submit"
                className="btn btn--solid-blue btn--full-width"
                value="Send"
              />
            </div>
          </div>
        </Formsy>
      </Modal>
    );
  }

  handleRTEChange = emailBody => {
    this.setState({ emailBody });
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  onSubmit = () => {
    const { recipients, emailBody } = this.state;

    const payload = {
      recipients: recipients.split(',').map(item => item.trim()),
      email_body: emailBody.toString('html')
    };

    menuAPI
      .sendMenu(this.props.menu.id, payload)
      .then(result => {
        this.props.addMessage({
          className: 'success',
          message: 'Email Sent Successfully'
        });
        this.props.closeModal();
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: `Error sending email: ${err}`
        });
        this.props.closeModal();
        console.log(err);
      });
  };

  deriveState() {
    let updatedState = null;
    if (this.state.menu !== this.props.menu) {
      const email = generateOccasionMenuEmail(this.props.menu) || '';
      const emailBody = createValueFromString(email, 'html');
      updatedState = {
        emailBody,
        menu: this.props.menu
      };
    }

    return updatedState;
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.menu !== prevProps.menu) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default withSplashMessage(MenuSendOccasionModal);



// WEBPACK FOOTER //
// ./src/components/menu/MenuSendOccasionModal.js